export default __webpack_public_path__ + "static/media/reparationPhone.fb1cea1f.jpg";